<template>
  <div class="about">
    <el-container class="flex">
      <el-header height="50px">
        <el-row class="header-row">
          <div class="search-box">
            <el-input class="search-input" prefix-icon="el-icon-search" size="medium" v-model.trim="searchText"
                      placeholder="支持应用名称/AppId等搜索" clearable @keyup.enter.native='inquireData'></el-input>
            <!--<el-button class="search-button" type="primary" @click="inquireData">搜索</el-button>-->
            <el-divider direction="vertical"></el-divider>
            <span class="sousuo-btn" @click="inquireData">搜索</span>
          </div>
          <!-- <el-button @click="resetData">重 置</el-button> -->
          <span class="docLink ponter">
            <img src="../../assets/img/wenjian.png" class="docIcon"/>
						<span @click="$message('敬请期待！');">开发文档</span>
					</span>
        </el-row>
      </el-header>
      <div class="app-area-list">
        <div v-if="!isSearching" class="box-add-xu">
          <div class="app-box" @click="openCreateApp">
            <img style="width: 25px;height: 25px" src="../../assets/img/cjyy.png" alt="">
            <span class="cjyy-span">创建应用</span>
          </div>
        </div>
        <div class="box-item" v-for="(app,index) in appListData" :key="index" @click="showDetail(app.id)">
          <div class="box-item-content">
            <div style="width: 50px;margin-right: 14px;">
              <img class="item-img" :src="$fileBaseUrl + '48x48/' + app.appLogo" alt="">
            </div>
            <div class="item-right">
              <div class="item-title"><span class="text-hover">{{ app.appName }}</span></div>
              <div class="item-content">
                <span class="text-hover">{{ app.appDescription }}</span>
              </div>
            </div>
          </div>
          <div class="box-item-bottom">
            <span :class="appState[app.appState].class">{{ appState[app.appState].text }}</span>
          </div>
        </div>
        <el-row v-if="appListData.length==0 && isSearching" class="empty-row" style="margin: 0 auto;text-align: center">
          <img src="../../assets/img/no-data.png"/>
          <div>&nbsp;暂无数据</div>
        </el-row>
      </div>
      <!--<el-main class="app-area">
        <el-row :gutter="20">
          <el-col :span="8" v-if="!isSearching">
            <div class="app-box box-add" @click="openCreateApp">
              <i class="el-icon-plus"></i>
              <span>创建应用</span>
            </div>
          </el-col>
          <el-col :span="8" v-for="(app,index) in appListData" :key="index">
            <div class="app-box box-info" @click="showDetail(app.id)">
              <el-container>
                <el-aside class="box-aside">
                  <img :src="$fileBaseUrl + '48x48/' + app.appLogo"/>
                </el-aside>
                <el-main class="box-main">
                  <span class="box-info-title"><span class="text-hover">{{ app.appName }}</span></span>
                  <p class="box-info-explain">
                    <span class="text-hover">{{ app.appDescription }}</span>
                  </p>
                </el-main>
              </el-container>
              <el-row class="box-footer">
                <span :class="appState[app.appState].class">{{ appState[app.appState].text }}</span>
              </el-row>
            </div>
          </el-col>
        </el-row>
        <el-row v-if="appListData.length==0 && isSearching" class="empty-row">
          <img src="../../assets/img/no-data.png"/>
          <div>&nbsp;暂无数据</div>
        </el-row>

      </el-main>-->
      <div class="pagination" v-if="appListData.length>0">
        <el-pagination @current-change="handleCurrentChange" background :total="dataCount" :page-size="pageSize"
                       :page-sizes="pageSizes"
                       @size-change="sizesChange"
                       layout='sizes,prev, pager, next, jumper, total'
        ></el-pagination>
      </div>
    </el-container>
    <el-dialog class="abow_dialog" title="创建应用" :visible.sync="dialogAddVisible" :before-close="handleClose"
               destroy-on-close>
      <el-form class="app-form">
        <el-form-item>
          <div class="label required">应用名称</div>
          <el-input size="medium" @blur="cleanBlank('name')" max="20" min="2" v-model="appName" maxlength="20"
                    placeholder="请输入至少2个字的名称" clearable show-word-limit></el-input>
          <p class="tip">名称可以由中文、数字、英文及下划线组成，长度控制在2-20个字符之间，名称必须符合法律法规，无色情低俗、侵权、暴力等非法字符，且不能出现政治倾向、政治色彩。</p>
        </el-form-item>
        <el-form-item>
          <div class="label required">应用描述</div>
          <el-input @keydown.native="keydownFunction" type="textarea" @blur="cleanBlank('desc')" placeholder="请输入应用描述"
                    v-model="appDescription" maxlength="100" :rows="4" show-word-limit style="width: 100%;"></el-input>
        </el-form-item>
        <el-form-item>
          <div class="label required">领域分类</div>
          <el-select v-model="appType" placeholder="请选择领域分类">
            <el-option v-for="item in appTypes" :key="item.id" :label="item.description" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div class="label">行业分类</div>
          <el-select v-model="industryType" placeholder="请选择行业分类">
            <el-option v-for="item in industryTypes" :key="item.industryId" :label="item.industryName" :value="item.industryId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div class="label">交付方式</div>
          <el-select v-model="buyType" placeholder="请选择交付方式">
            <el-option v-for="item in buyTypes" :key="item.deliveryMethodId" :label="item.deliveryMethodName" :value="item.deliveryMethodId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="buyType != '' && buyType != 2">
          <div class="label required">下载地址</div>
          <el-input
                      placeholder="请输入下载地址"
                      v-model="linkUrl">
                      <template slot="prepend">https://</template>
                    </el-input>
        </el-form-item>
        <el-form-item >
          <div class="label">是否私有化部署</div>
          <el-switch
              v-model="isSiYouHua"
              :active-value="1"
              :inactive-value="0">
          </el-switch>
        </el-form-item>

        <el-form-item>
          <div class="label required">上传应用图册</div>
          <el-upload class="album-uploader" :limit="5" accept="image/jpeg,image/png" :before-upload="beforeUpload"
                     :on-exceed="handleExceed" action="#" :http-request='uploadAttach' list-type="picture-card"
                     :on-preview="handlePictureAlbumPreview" :on-remove="handlePictureAlbumRemove"
                     :on-success="handleAlbumSuccess">
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog title="预览" class="abow_dialog" :visible.sync="dialogPreviewVisible" append-to-body>
            <img width="100%" :src="previewImageUrl" alt="">
            <span slot="footer">
              <el-button @click="dialogPreviewVisible = false">取消</el-button>
            </span>
          </el-dialog>
        </el-form-item>
        <el-form-item>
          <div class="label required">TIPS标签：</div>
          <el-tag :key="tag" v-for="tag in appTags" closable :disable-transitions="true" @close="delTag(tag)"
                  effect="plain" type="info" style="height: 32px;line-height: 32px;"> {{ tag }}
          </el-tag>
          <el-input class="input-new-tag" v-if="tagInputVisible" v-model="tagInputValue" ref="saveTagInput" size="small"
                    @keyup.enter.native="tagInputConfirm" @blur="tagInputConfirm"></el-input>
          <el-button v-if="!tagInputVisible&&appTags.length<6" class="button-new-tag"
                     :style="{'margin-left': appTags.length>0?'10px':'0px', 'min-width': '96px', 'font-size': '14px'}"
                     size="small" @click="showInput">+
          </el-button>
        </el-form-item>
        <el-form-item>
          <div class="label required" style="height: 60px;line-height: 60px;">应用Logo</div>
          <el-upload v-loading="uploadLoading"
                     class="avatar-uploader"
                     accept="image/jpeg,image/png"
                     action="#"
                     :http-request='uploadFile'
                     :show-file-list="false"
                     :on-error="handleAvatarError"
                     :on-success="handleAvatarSuccess"
                     :on-change='beforeAvatarUpload'
                     :auto-upload="false"
                     style="width: 100px;float: left;">
            <img v-if="imageUrl" :src="imageUrl" class="avatar" alt=""/>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <p class="tip logo-tip">请上传JPG/PNG格式、240*240px以上、1:1 、1M 以内的图标</p>
          <!-- vueCropper 剪裁图片实现-->
          <el-dialog class="abow_dialog" title="图片剪裁" width="40%" :visible.sync="dialogVisible" append-to-body>
            <div class="cropper-content">
              <div class="cropper" style="text-align:center">
                <vueCropper
                    ref="cropper"
                    :img="option.img"
                    :outputSize="option.size"
                    :outputType="option.outputType"
                    :info="true"
                    :full="option.full"
                    :canMove="option.canMove"
                    :canMoveBox="option.canMoveBox"
                    :original="option.original"
                    :autoCrop="option.autoCrop"
                    :fixed="option.fixed"
                    :fixedNumber="option.fixedNumber"
                    :centerBox="option.centerBox"
                    :infoTrue="option.infoTrue"
                    :fixedBox="option.fixedBox"
                    :autoCropWidth="option.autoCropWidth"
                    :autoCropHeight="option.autoCropHeight"
                    @realTime="realTime"
                    :mode="option.mode"
                ></vueCropper>
              </div>
              <div style="margin-left:20px;">
                <div class="show-preview" style="width: 150px;height: 150px;overflow: hidden;margin: 5px">
                  <div class="preview"
                       :style="{ width: previews.w + 'px' , height: previews.h + 'px' , transform:`scale(calc(150 / ${previews.w}),calc(150 / ${previews.h}))`,  overflow: 'hidden', }"
                       style="transform-origin:0 0">
                    <img :src="previews.url" :style="previews.img" alt=""/>
                  </div>
                </div>
                <div class="show-preview" style="width: 100px;height: 100px;overflow: hidden;margin: 5px">
                  <div class="preview"
                       :style="{ width: previews.w + 'px' , height: previews.h + 'px' , transform:`scale(calc(100 / ${previews.w}),calc(100 / ${previews.h}))`,  overflow: 'hidden', }"
                       style="transform-origin:0 0">
                    <img :src="previews.url" :style="previews.img" style="object-fit: fill" alt=""/>
                  </div>
                </div>
                <div class="show-preview" style="width: 50px;height: 50px;overflow: hidden;margin: 5px">
                  <div class="preview"
                       :style="{ width: previews.w + 'px' , height: previews.h + 'px' , transform:`scale(calc(50 / ${previews.w}),calc(50 / ${previews.h}))`,  overflow: 'hidden', }"
                       style="transform-origin:0 0">
                    <img :src="previews.url" :style="previews.img" alt=""/>
                  </div>
                </div>
              </div>
            </div>
            <div style="margin-top: 20px">
              <el-button type="primary" @click="changeScale(1)">放大图片</el-button>
              <el-button type="primary" @click="changeScale(-1)">缩小图片</el-button>
              <!--<el-button type="primary" @click="$refs.cropper.clearCrop()">重置图片</el-button>-->
            </div>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false,uploadLoading=false">取 消</el-button>
              <el-button type="primary" @click="finish">确认</el-button>
            </div>
          </el-dialog>
        </el-form-item>
        <el-form-item>
          <div class="label">应用简介：</div>
          <el-button type="primary" plain @click="showEdit('appIntroduction')">编辑</el-button>
        </el-form-item>
         <el-form-item >
          <div class="label">界面展示：</div>
           <el-button type="primary" plain @click="showEdit('interfaceDisplay')">编辑</el-button>
        </el-form-item>
        <el-form-item >
          <div class="label">功能模块：</div>
         <el-button type="primary" plain @click="showEdit('functionBlock')">编辑</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog()">取 消</el-button>
        <el-button type="primary" @click="createApp()">确定创建</el-button>
      </div>
    </el-dialog>

     <el-dialog
      :title="`编辑${editorTypeObj[editorType]}`"
      :visible.sync="dialogVisibleEditor"
      v-if="dialogVisibleEditor"
      width="60%"
      :before-close="handleCloseEdit"
    >
      <Editor ref="Editor" funcName="AppDetailImage" editId="cEditor" :menus="editorMenus" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseEdit">取 消</el-button>
        <el-button type="primary" @click="saveadd">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  CacheService
} from "@/service/common";
import {Evens} from '@/utils';
import axios from 'axios';
import Editor from "../../components/wangeditor";
export default {
  name: "Inside",
  components: { Editor },
  data() {
    return {
      editorType:'',
      editorTypeObj:{
        functionBlock:'功能模块',
        interfaceDisplay:"界面展示",
        appIntroduction:"应用简介"
      },
      functionBlock:"",//功能模块
      interfaceDisplay:'',//界面展示
      appIntroduction:"",//应用简介
      dialogVisibleEditor:false,
      editorMenus: [
        "head", // 标题
        "bold", // 粗体
        "fontSize", // 字号
        "fontName", // 字体
        "italic", // 斜体
        "underline", // 下划线
        // "strikeThrough", // 删除线
        "foreColor", // 文字颜色
        // "backColor", // 背景颜色
        // "link", // 插入链接
        // "list", // 列表
        "justify", // 对齐方式
        "quote", // 引用
        //"emoticon", // 表情
        "image", //图片
        "table", // 表格
        // "code", // 插入代码
        "undo", // 撤销
        "redo", // 重复
      ],
      linkUrl:'',
      industryType:'',
      industryTypes:[],
      buyType:"",
      buyTypes:[{
        deliveryMethodId:1,
        deliveryMethodName:'下载'
      },
      {
        deliveryMethodId:2,
        deliveryMethodName:'SAAS'
      },
      {
        deliveryMethodId:3,
        deliveryMethodName:'程序封装'
      }],
      pageSizes: [10, 20, 50, 100],
      nav: [],
      appTypes: [],
      appSource: 2, //0基础应用  1企业自建（企业内部）  2平台合作（第三方）
      // 0.默认状态 1待审核 2 审合通过(上线) 3审核拒绝 4 客户下架 5平台下架 6 删除
      appState: {
        "0": {"class": "box-app-state color-gray", "text": '等待提交审核'},
        "1": {"class": "box-app-state color-yellow", "text": '待审核'},
        "2": {"class": "box-app-state color-green", "text": '审核通过(上线)'},
        "3": {"class": "box-app-state color-red", "text": '审核失败(重新提交审核)'},
        "4": {"class": "box-app-state color-red", "text": '下架'},
        "5": {"class": "box-app-state color-red", "text": '下架'},
        "6": {"class": "box-app-state color-red", "text": '已删除'}
      },
      searchText: '', //搜索关键词
      appListData: [],//应用列表
      pageIndex: 1,//当前页码
      pageSize: 10,
      dataCount: 0,//应用数量
      uploadLoading: false,

      dialogPreviewVisible: false,//图册大图展示
      previewImageUrl: '',//展示的应用图册路径
      appAlbum: [],//应用图册

      dialogAddVisible: false, //创建应用窗口
      appName: '', //应用名称
      imageUrl: '', //应用Logo展示url
      appLogoData: {},//应用Logo
      appDescription: '', //应用简介
      appType: '',
      appTags: [],//应用标签
      tagInputVisible: false,
      tagInputValue: '',
      isSearching: false,
      dialogVisible: false,
      // 裁剪组件的基础配置option
      option: {
        img: '', // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 1, // 裁剪生成图片的质量
        outputType: 'png', // 裁剪生成图片的格式
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 200, // 默认生成截图框宽度
        autoCropHeight: 200, // 默认生成截图框高度
        fixedBox: false, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [1, 1], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMoveBox: true, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        mode: 'cover'
      },
      picsList: [],  //页面显示的数组
      previews: {},

      isSiYouHua:0, //是否私有化部署
    };
  },
  
  mounted() {
    this.nav = this.$router;
  },
  //computed: mapState(["breadcrumb"]),
  // watch: {
  //   breadcrumb(val) {
  //   },
  // },
  created() {
    this.getApplicationPageList();
    this.getAppTypes();
    this.getIndustryTypes()
    Evens.on('del-app', (id) => {
      let index = this.appListData.findIndex(_a => {
        return _a.id == id
      });
      if (index != -1) {
        this.appListData.splice(index, 1);
      }
      if (!this.appListData.length) {
        this.pageIndex = 1;
      }
      this.getApplicationPageList();
    })
    Evens.on('modify-app', (data) => {
      let app = this.appListData.find(_a => {
        return _a.id == data.id
      });
      app && Object.assign(app, data);
    })
  },
  methods: {
    saveadd(){
      this[this.editorType] = this.$refs.Editor.getHtml()
      this.$refs.Editor.destroy();
      this.dialogVisibleEditor = false;
    },
    handleCloseEdit() {
      this.$refs.Editor.destroy();
      this.dialogVisibleEditor = false;
    },
    showEdit(type){
      const that = this
      this.dialogVisibleEditor = true
      this.editorType = type
      this.$nextTick(()=>{
        if(that[that.editorType] !== undefined){
          this.$refs.Editor.setHtml(that[that.editorType])
        }else{
          this.$refs.Editor.setHtml('')
        }
      })
      
    },
    getIndustryTypes(){
      let url = "/Opencloud/Application/ApplicationIndustryList"
      this.axios.get(url).then((res) => {
        console.log(res)
        this.industryTypes = res;
      })
    },
    //放大/缩小
    changeScale(num) {
      num = num || 1;
      this.$refs.cropper.changeScale(num);
    },
    // 实时预览函数
    realTime(data) {
      this.previews = data
    },
    beforeAvatarUpload(file) {
      let types = ['image/jpeg', 'image/jpg', 'image/png'];
      const isImage = types.includes(file.raw.type);
      if (!isImage) {
        this.uploadLoading = false;
        this.$message.error('上传图片只能是 JPG、JPEG、PNG、GIF 格式!');
        return false
      }
      const isLt = file.size / 1024 <= 1024;
      if (!isLt) {
        this.uploadLoading = false;
        this.$message.warning("上传logo大小小于等于1M");
        return false
      }
      this.uploadLoading = true;
      // 获取上传图片的本地URL，用于上传前的本地预览
      var URL = null;
      if (window.createObjectURL != undefined) {
        // basic
        URL = window.createObjectURL(file.raw);
      } else if (window.URL != undefined) {
        // mozilla(firefox)
        URL = window.URL.createObjectURL(file.raw);
      } else if (window.webkitURL != undefined) {
        // webkit or chrome
        URL = window.webkitURL.createObjectURL(file.raw);
      }
      file.url = URL;
      this.fileinfo = file
      // 上传成功后将图片地址赋值给裁剪框显示图片
      this.$nextTick(() => {
        this.option.img = file.url
        this.dialogVisible = true
      })
    },
    // 点击裁剪，这一步是可以拿到处理后的地址
    finish() {
      this.$refs.cropper.getCropBlob((data) => {
        this.uploadLoading = true
        const formdata = new FormData()
        formdata.append('file', data, this.fileinfo.name)
        let fileExt1 = this.fileinfo.name.substring(this.fileinfo.name.lastIndexOf("."));
        let fileExt2 = this.fileinfo.name.substring(this.fileinfo.name.lastIndexOf(".") + 1);
        let url = 'Opencloud/File/MinioUploadURL?fileExt=' + fileExt2 + '&funcName=AppLogo ';
        this.$axios.get(url).then((message) => {
          if (message) {
            this.$uaxios.put(message.uploadPath,
                data).then((res) => {
              if (res.status === 200) {
                res.filePath = message.filePath;
                res.fileExt = fileExt1;
                this.dialogVisible = false
                this.handleAvatarSuccess(res)
              } else {
                this.uploadLoading = false
                this.$message.error("上传失败！")
              }
            }, (err) => {
              this.uploadLoading = false
              this.$message.error("上传失败！")
            })
          }
        })
      })
    },
    keydownFunction(event) {
      if (event.keyCode === 13) {
        event.preventDefault(); // 阻止浏览器默认换行操作
        return false;
      }
    },
    onLoad() {
    },
    back() {
      this.$router.back();
    },
    // 关闭新建应用弹窗之前
    handleClose(done) {
      done();
    },
    cleanBlank(type) {
      if (type == 'name') {
        this.appName = this.appName.replace(/\s*/g, "");
      } else {
        this.appDescription = this.appDescription.replace(/\s*/g, "");
      }
    },
    addAppLogo() {
      this.$refs.addImg.dispatchEvent(new MouseEvent('click'))
    },
    // 移除某个图册
    handlePictureAlbumRemove(file) {
      this.appAlbum.splice(this.appAlbum.indexOf(file.response.data), 1);
      // if (this.appAlbum.length == 5) {
      // 	document.getElementsByClassName("el-upload")[0].style.display = "none";
      // } else {
      // 	document.getElementsByClassName("el-upload")[0].style.display = "inline-block";
      // }
    },
    beforeUpload(file) {
      //const isLt2M = file.size / 1024 / 1024 < 5;
      if (!['image/jpeg', 'image/png'].includes(file.type)) {
        this.$message.warning("只能上传图片!");
        return false
      }
      // const isLt = file.size /1024 <= 1024;
      // if (!isLt) {
      //   this.$message.warning("文件大小不能超过1M!");
      //   return false
      // }
    },
    // 查看图册大图
    handlePictureAlbumPreview(file) {
      this.previewImageUrl = file.url;
      this.dialogPreviewVisible = true;
    },
    // 上传图册成功
    handleAlbumSuccess(res) {
      console.log(res);
      if (res.data) {
        res.data.appFile = JSON.parse(JSON.stringify(res.data));
        res.data.compId = this.$store.state.comp.compId;
        this.appAlbum.push(res.data);
      }
      // if (this.appAlbum.length == 5) {
      // 	document.getElementsByClassName("el-upload")[0].style.display = "none";
      // } else {
      // 	document.getElementsByClassName("el-upload")[0].style.display = "inline-block";
      // }
    },
    // 图册数量超出限制
    handleExceed(files, fileList) {
      this.$message.warning(`最多上传5张应用图册`);
    },
    async uploadAttach(event) {
      let fileExt1 = event.file.name.substring(event.file.name.lastIndexOf('.'));
      let fileExt2 = event.file.name.substring(event.file.name.lastIndexOf('.') + 1);
      let urlData = await this.$axios.get('Opencloud/File/MinioUploadURL?fileExt=' + fileExt2 + '&funcName=AppAttach');
      let fileData = await axios.put(urlData.uploadPath, event.file, {headers: {'Content-Type': ''}})
      if (fileData.status == 200) {
        return {data: {filePath: urlData.filePath, fileName: event.file.name, fileExt: fileExt1}};
      } else {
        throw new Error('上传失败');
      }
    },
    //自定义上传方法
    async uploadFile(event) {
      let fileExt1 = event.file.name.substring(event.file.name.lastIndexOf('.'));
      let fileExt2 = event.file.name.substring(event.file.name.lastIndexOf('.') + 1);
      let urlData = await this.$axios.get('Opencloud/File/MinioUploadURL?fileExt=' + fileExt2 + '&funcName=AppLogo');
      let fileData = await axios.put(urlData.uploadPath, event.file, {headers: {'Content-Type': ''}})
      if (fileData.status == 200) {
        return {data: {filePath: urlData.filePath, fileName: event.file.name, fileExt: fileExt1}};
      } else {
        throw new Error('上传失败');
      }
    },
    // 上传应用logo回调
    handleAvatarSuccess(res) {
      this.uploadLoading = false;
      this.appLogoData = {
        filePath: res.filePath
      };
      this.imageUrl = this.$fileBaseUrl + '96x96/' + this.appLogoData.filePath.replace(/\\/g, "/");
    },
    handleAvatarError() {
      this.uploadLoading = false;
      this.$message.error("上传应用Logo失败");
    },
    sizesChange(val) {
      this.pageSize = val;
      this.getApplicationPageList();
    },
    // currentPage 改变
    handleCurrentChange(page) {
      this.pageIndex = page;
      this.getApplicationPageList();
    },
    /*beforeAvatarUpload(file) {

      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const limit = file.size / 1024 < 1024;
      if (!limit) {
        this.$message.error('上传图片大小不能超过 1M!');
        return false;
      }
      let sure = (isJPG || isPNG) && limit;
      if (sure) {

        this.uploadLoading = true;
      } else{
        this.$message.warning("只能上传图片!");
        this.uploadLoading = false;
      }
      return sure;
    },*/
    // 删除某个标签
    delTag(tag) {
      this.appTags.splice(this.appTags.indexOf(tag), 1);
    },
    // 显示新增标签input
    showInput() {
      this.tagInputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    // 保存标签
    tagInputConfirm() {
      if (this.tagInputValue.trim() == '') {
        this.tagInputVisible = false;
        this.tagInputValue = '';
        return;
      }
      let tagInputValue = this.tagInputValue;
      if (tagInputValue.length > 6) {
        this.$message.warning("标签不能超过6个字");
        this.$refs.saveTagInput.$refs.input.focus();
        return;
      }
      let has = false;
      this.appTags.forEach(i => {
        if (tagInputValue == i) {
          this.$message.error('该标签已存在');
          this.tagInputVisible = false;
          this.tagInputValue = '';
          has = true;
        }
      })
      if (has) {
        return;
      }
      if (tagInputValue) {
        this.appTags.push(tagInputValue.replace(/\s*/g, ""));
      }
      this.tagInputVisible = false;
      this.tagInputValue = '';
    },
    showDetail(id) {
      this.$router.push({path: '/Third-detail?id=' + id})
    },
    inquireData() {
      // if (this.searchText.trim() == '') {
      // 	this.$message.warning('请输入搜索关键词');
      // 	this.searchText = '';
      // 	return;
      // }
      this.isSearching = this.searchText ? true : false;
      this.getApplicationPageList();
    },
    resetData() {
      this.searchText = '';
      this.isSearching = false;
      this.getApplicationPageList();
    },
    // 获取应用列表
    getApplicationPageList() {
      this.appListData.length = 0;
      let url = '/Opencloud/Application/ApplicationPageList?pageSize=' + this.pageSize + '&pageIndex=' + this.pageIndex + '&appSource=2';
      this.searchText.trim() && (url += '&keyWords=' + this.searchText.trim());
      this.axios.get(url).then((res) => {
        this.appListData = res.data;
        this.dataCount = res.dataCount;
      })
    },
    // 获取应用分类字典
    getAppTypes() {
      let url = '/Opencloud/Dictionary/AppTypeDictionaryValueByDicKey?dicKey=Maidi_Application_Type';
      this.axios.get(url).then((res) => {
        this.appTypes = res;
      })
    },
    closeDialog() {
      
      this.appName = '';
      this.imageUrl = '';
      this.appDescription = '';
      this.appTags = [];
      this.tagInputVisible = false;
      this.tagInputValue = '';
      this.appType = '';
      this.appAlbum = [];
      this.functionBlock='';
      this.interfaceDisplay="";
      this.appIntroduction="";
      this.dialogAddVisible = false;

    },
    openCreateApp() {
      let compInfo = CacheService.get("comp");
      //只有服务商认证才能创建第三方应用
      if (compInfo.compLevel == 4 && compInfo.auditStatus == 2) {
        this.dialogAddVisible = true;
      } else {
        this.$message.error('没有权限！');
      }
    },
    createApp() {
      if (this.appName.trim() == '') {
        this.$message.warning('请输入应用名称');
        return;
      }
      if (this.appDescription.trim() == '') {
        this.$message.warning('请输入应用描述');
        return;
      }
      if (this.appName.length < 2 || this.appName.length > 20) {
        this.$message.warning('应用名称请输入 2 到 20 个字符');
        return;
      }
      if (this.tagInputVisible) {
        this.$message.warning('请确认未保存的标签');
        return;
      }
      if (this.appType == '') {
        this.$message.warning('请选择领域分类');
        return;
      }
      if (this.appAlbum.length == 0) {
        this.$message.warning('请上传应用图册');
        return;
      }
      if (this.appTags.length == 0) {
        this.$message.warning('请添加至少一个TIPS标签');
        return;
      }
      if (!this.imageUrl) {
        this.$message.warning('请上传应用logo');
        return;
      }
      if(this.buyType!=2 && this.buyType!=0 && this.buyType!="" && this.linkUrl == ''){
        this.$message.warning('请填入下载地址');
        return;
      }
      let industryName= "";
      let deliveryMethodName = ""
      if(this.industryType!= ""){
        industryName = this.industryTypes.find(item => item.industryId == this.industryType).industryName;
      }
      if(this.buyType != ""){
        deliveryMethodName = this.buyTypes.find(item => item.deliveryMethodId == this.buyType).deliveryMethodName;
      }
      
      let postdata = {
        id: 0,
        appSource: this.appSource,
        appName: this.appName,
        appDescription: this.appDescription,
        appLogoFile: this.appLogoData,
        appTypeId: this.appType,
        appCompName: this.$store.state.comp.compName,
        appTag: this.appTags.join(','),
        attachList: this.appAlbum,
        isPrivateApp:this.isSiYouHua,
        industryId:this.industryType,
        industryName:industryName,
        deliveryMethodId:this.buyType,
        deliveryMethodName:deliveryMethodName,
        functionBlock:this.functionBlock,
        interfaceDisplay:this.interfaceDisplay,
        appIntroduction:this.appIntroduction,
        linkUrl:this.linkUrl
      }
      
      this.axios.post('/Opencloud/Application/AddApplication', postdata).then((res) => {
        if (res) {
          this.closeDialog();
          this.$message.success('新建应用成功，点击应用进行进一步配置');
          this.pageIndex=1;
          this.resetData();
        } else {
          this.$message.error("创建应用失败");
        }
      })
    }
  }
};
</script>
<style lang="scss" scoped>

::v-deep .el-header {
  padding: 0;
}


.app-area-list {
  padding-top: 0 !important;
  display: flex;
  flex-wrap: wrap;
  overflow: auto;
  margin-top: 20px;

  .box-add-xu {
    width: 300px;
    height: 160px;
    border: 1px dashed #d4dae2;
    border-radius: 15px;
    margin-right: 20px;
    margin-bottom: 20px;

    .app-box {
      width: 300px;
      height: 160px;
      border-radius: 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      cursor: pointer;

      .cjyy-span {
        font-size: 15px;
        color: #333333;
        margin-top: 12px;
      }
    }
  }

  .box-item {
    width: 300px;
    height: 160px;
    border: 1px solid #dde2e7;
    border-radius: 15px;
    margin-right: 20px;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;

    .box-item-content {
      flex: 1;
      display: flex;
      padding: 18px 14px 0 14px;

      .item-img {
        width: 52px;
        height: 52px;
        border-radius: 10px;
      }

      .item-right {
        .item-title {
          font-size: 14px;
          margin-bottom: 10px;
          color: #333333;
          font-weight: 400;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }

        .item-content {
          font-size: 12px;
          color: #586169;
          font-weight: 400;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;

          .text-hover {
            overflow: hidden;
            word-break: break-all;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
          }
        }
      }
    }

    .box-item-bottom {
      height: 42px;
      opacity: 1;
      background: #f8f9fa;
      border-radius: 0 0 15px 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
    }
  }

}

// 截图
.cropper-content {
  display: flex;

  .cropper {
    width: 70%;
  }

  .cropper3 {
    width: 30%;
    margin-left: 50px;
  }
}

.about {
  overflow-y: auto;
}

.text-hover:hover {
  text-decoration: underline;
}

::v-deep .el-dialog {
  min-width: 700px;
  border-radius: 12px !important;
}

.flex {
  display: flex;

  .header-row {
    margin-top: 8px;

    .search-box {
      display: inline-block;
      border: 1px solid #d9d9d9;
      border-radius: 9px;
      width: 304px;

      ::v-deep .el-input--medium .el-input__icon {
        line-height: 32px;
      }

      .search-input {
        width: 242px;;
        height: 32px;
        border-radius: 0;
        border-color: transparent;
        border-top-left-radius: 9px;
        border-bottom-left-radius: 9px;

        ::v-deep input {
          height: 32px;
          line-height: 32px;
          font-size: 12px;
          border: none;
          border-radius: 0;
          border-color: transparent !important;
          border-top-left-radius: 9px;
          border-bottom-left-radius: 9px;
        }
      }

      .search-button {
        height: 32px;
        width: 62px;
        line-height: 0;
        background-color: #F6F7FBFF !important;
        color: #1890FFFF !important;
        border-color: transparent !important;
        margin-left: 0;
        border-radius: 0;
        font-size: 12px;
        border-top-right-radius: 3px;
        border-bottom-right-radius: 3px;
      }

      .sousuo-btn {
        height: 14px;
        font-size: 14px;
        color: #567afb;
        margin-left: 5px;
      }
    }

    .docIcon {
      width: 18px;
      height: 19px;
    }

    .docLink {
      color: #3063e7;
      font-size: 12px;
      margin-top: 8px;
      margin-left: 36px;
      width: 85px;
      text-decoration: underline;

      span {
        padding-left: 6px;
      }

      img {
        margin-bottom: -5px;
      }
    }
  }

  ::v-deep .el-pagination {
    float: right;
  }
}

.title {
  padding: 0 0 15px;
}

.filterBtn {
  width: 98px;
}

input {
  border-radius: 3px !important;
  /*height: 36px !important;*/
}

button {
  /*height: 36px !important;*/
}


.app-area {
  padding-top: 0 !important;
  overflow: hidden;
  overflow-y: auto;

  .pagination {
    float: right;
    margin-top: 26px;
  }

  .app-box {
    background: #FFFFFF;
    width: 363px !important;
    height: 184px;
    cursor: pointer;
    margin-top: 24px;
  }

  .box-add {
    text-align: center;
    line-height: 184px;
    border: 1px #1B9AEEFF;
    border-style: dashed;

    i {
      font-weight: bold;
      color: #1B9AEEFF;
      font-size: 12px;
      margin-right: 8px;
    }

    span {
      color: #1B9AEEFF;
      font-size: 16px;
    }
  }

  .box-info {
    border: 1px #E8E8E8;
    border-style: solid;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.09);

    .box-aside {
      width: 24% !important;
      text-align: center;
      line-height: 140px;

      img {
        object-fit: cover;
        width: 48px;
        height: 48px;
        border-radius: 24px;
        margin-left: 20px;
      }
    }

    .box-main {
      padding: 20px 22px 2px;
      width: 76%;
    }

    .box-info-title {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #000000D9;
      text-align: left;
      display: inline-block;
      width: 100%;
    }

    .box-footer {
      background-color: #F7F9FAFF;
      width: 100%;
      height: 45px;
      text-align: center;

      .box-app-state {
        font-size: 14px;
        line-height: 45px;
        padding-right: 8px;
      }
    }

    .box-info-explain {
      color: #00000073;
      font-size: 14px;
      margin-top: 12px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  }

  .empty-row {
    color: #999999FF;
    height: 40%;
    display: flex;
    align-items: center;
    left: 42%;
  }
}


.app-form {
  .label {
    color: #000000FF;
    width: 100%;;
    font-size: 14px;
    display: inline-block;
    float: left;
  }

  .tip {
    color: #999999FF;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 17px;
    margin-top: 8px;
  }

  .logo-tip {
    margin-top: 140px;
    margin-left: 108px;
  }

  .el-tag + .el-tag {
    margin-left: 10px;
  }

  .button-new-tag {
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }

  .input-new-tag {
    width: 90px;
    margin-left: 10px !important;
    vertical-align: bottom;
  }

  .album-uploader {
    ::v-deep .el-upload,
    ::v-deep .el-upload-list__item {
      width: 105px !important;
      height: 105px !important;
      line-height: 105px !important;
      margin: 10px 10px 10px 0 !important;

      .el-icon-upload-success {
        position: absolute;
        right: 14px;
        top: 1px;
      }
    }

    ::v-deep .el-upload {
      border: 1px dashed #d9d9d9 !important;
      line-height: 135px;
    }

    ::v-deep .el-progress {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      bottom: auto;
      width: 98px !important;
    }

    ::v-deep .el-progress-circle {
      width: 98px !important;
      height: 98px !important;
    }
  }

  .avatar-uploader {
    .el-upload {
      border: 1px dashed #d9d9d9 !important;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    .el-upload:hover {
      border-color: #409EFF;
    }

    .avatar {
      width: 96px;
      height: 96px;
      display: block;
      border-radius: 15px;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 96px;
      height: 96px;
      line-height: 96px !important;
      text-align: center;
      border: 1px dashed #d9d9d9 !important;
      border-radius: 15px;
    }
  }
}


</style>
